var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUnion(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 404,
    height: 585,
    viewBox: "0 0 404 585",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M257.75 292.5H205.1V0H199.25V292.5H175.85V0H170V292.5H146.6V0H140.75V292.5H117.35V0H111.5V292.5H-181V298.35H111.5V321.75H-181V327.6H111.5V351H-181V356.85H111.5V380.25H-181V386.1H111.5V438.75C111.5 519.522 176.978 585 257.75 585C338.522 585 404 519.522 404 438.75C404 357.978 338.522 292.5 257.75 292.5ZM140.75 321.75H117.35V298.35H140.75V321.75ZM146.6 321.75H170V298.35H146.6V321.75ZM175.85 321.75H199.25V298.35H175.85V321.75ZM205.1 321.75V298.35H257.75C335.291 298.35 398.15 361.209 398.15 438.75C398.15 516.291 335.291 579.15 257.75 579.15C180.209 579.15 117.35 516.291 117.35 438.75V386.1H140.75V438.75C140.75 503.367 193.133 555.75 257.75 555.75C322.367 555.75 374.75 503.367 374.75 438.75C374.75 374.133 322.367 321.75 257.75 321.75H205.1ZM140.75 380.25H117.35V356.85H140.75V380.25ZM146.6 386.1V438.75C146.6 500.136 196.364 549.9 257.75 549.9C319.136 549.9 368.9 500.136 368.9 438.75C368.9 377.364 319.136 327.6 257.75 327.6H205.1V351H257.75C306.213 351 345.5 390.287 345.5 438.75C345.5 487.213 306.213 526.5 257.75 526.5C209.287 526.5 170 487.213 170 438.75V386.1H146.6ZM175.85 351H199.25V327.6H175.85V351ZM170 327.6V351H146.6V327.6H170ZM170 356.85V380.25H146.6V356.85H170ZM175.85 438.75V386.1H199.25V438.75C199.25 471.059 225.441 497.25 257.75 497.25C290.059 497.25 316.25 471.059 316.25 438.75C316.25 406.441 290.059 380.25 257.75 380.25H205.1V356.85H257.75C302.982 356.85 339.65 393.518 339.65 438.75C339.65 483.982 302.982 520.65 257.75 520.65C212.518 520.65 175.85 483.982 175.85 438.75ZM205.1 438.75C205.1 467.828 228.672 491.4 257.75 491.4C286.828 491.4 310.4 467.828 310.4 438.75C310.4 409.672 286.828 386.1 257.75 386.1H205.1V438.75ZM199.25 380.25V356.85H175.85V380.25H199.25ZM140.75 351H117.35V327.6H140.75V351Z",
    fill: "url(#paint0_linear_2232_488)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2232_488",
    x1: 351.35,
    y1: 552.825,
    x2: -181,
    y2: -11.7,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8C864"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F8C864",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnion);
export default __webpack_public_path__ + "static/media/Union.c3df6fa8e76f57be19e86ba7ed7966c9.svg";
export { ForwardRef as ReactComponent };